<template>
  <div class="component-card">
    <div class="d-flex">
      <i
        class="fa fa-arrow-left fa-lg font-weight-bold cursor-pointer m__r--10 m__t--2"
        @click="cancelData"/>
      <h3>UPDATED DOKUMEN {{ dataDetail ? dataDetail.category_name.toUpperCase() : '' }}</h3>
    </div>

    <h4>DETAIL DOKUMEN</h4>
    <b-row>
      <b-col md="8">
        <b-row>
          <b-col md="6">
            <b-form-group>
              <label> Id </label>
              <j-input
                v-model="dataDetail.id"
                :disabled="true"
                placeholder="Id"/>
            </b-form-group>
          </b-col>
          <b-col md="6">
            <b-form-group>
              <label> Status </label>
              <j-input
                v-model="dataDetail.status"
                :disabled="true"
                placeholder="Status"/>
            </b-form-group>
          </b-col>
        </b-row>

        <b-form-group :class="{'error-input' : $v.data_master.title.$error}">
          <label> Title </label>
          <j-input
            v-model="$v.data_master.title.$model"
            :max-length="255"
            :disabled="disableAction"
            placeholder="Insert Title"/>
        </b-form-group>

        <b-form-group
          v-show="disableAction"
          :class="{'error-input' : $v.data_master.category.$error}">
          <label> Category </label>
          <j-single-select
            v-model="$v.data_master.category.$model"
            :options="list_category"
            :disabled="true"
            :placeholder="'Select Category'"
            value-format="object"
            label="label"/>
        </b-form-group>

        <b-form-group>
          <label> Attachment </label>
          <j-upload-file
            v-model="$v.data_master.file.$model"
            :accepted-file-type="['xls', 'xlsx', 'docx', 'doc', 'pdf', 'jpg', 'png', 'jpeg']"
            :api-token="token"
            :img-default="$v.data_master.file.$model"
            :name-default="fileNameDefault"
            :url-upload="url_upload"
            :disabled="disableAction"
            @url="getUrl"/>
        </b-form-group>

        <j-form-base
          v-if="showAdditionalInfo"
          ref="jFormCreate"
          :data-fields="dataFields"
          :is-detail="true"
          :is-disabled="disableAction"/>

        <b-row>
          <b-col md="6">
            <b-button
              v-if="actionRequester"
              class="btn red m__t--20"
              @click="deleteData">
              Delete
            </b-button>
            <b-button
              v-if="actionApprover"
              class="btn blue m__r--5 m__t--20"
              @click="approveData">
              Approve
            </b-button>
            <b-button
              v-if="actionApprover"
              class="btn red m__r--5 m__t--20"
              @click="rejectData">
              Reject
            </b-button>
          </b-col>
          <b-col md="6">
            <div class="float-to-right m__t--20">
              <b-button
                v-if="actionRequester"
                class="btn green m__r--5"
                @click="submitData">
                Submit
              </b-button>
              <b-button
                v-if="actionRequester"
                class="btn blue m__r--5"
                @click="saveData">
                Update
              </b-button>
            </div>
          </b-col>
        </b-row>
      </b-col>
      <b-col md="4">
        <h4>LOG PROCESS</h4>
        <j-log :data-log="dataLog" />

        <h4>HASIL GENERATE</h4>
        <div
          v-if="fileGenerate"
          class="btn-download-surat"
          @click="downloadSurat(fileGenerate)">
          <img :src="require('@/assets/image/surat.png')">
          DOWNLOAD SURAT
        </div>
      </b-col>
    </b-row>
  </div>
</template>

<script>
/* eslint-disable no-unused-vars, no-console, max-len */
import { mapActions, mapState } from 'vuex';
import { required, requiredIf } from 'vuelidate/lib/validators';
import jFormBase from '@/views/kurikulum/additional-info/jFormBase';
import jUploadFile from '@/components/upload-file/jUploadFile';
import jLog from '@/components/log/jLog';

export default {
  components: {
    jFormBase,
    jUploadFile,
    jLog,
  },
  data() {
    return {
      title: {
        icon: 'fa-file',
        main_title: 'Update Data',
      },

      data_master: {
        title: '',
        category: null,
        file: null,
      },
      list_category: [],
      token: (JSON.parse(localStorage.getItem('Token'))).value,
      showAdditionalInfo: false,
      dataFields: [],
      fileGenerate: '',
      dataDetail: null,
      fileNameDefault: '',
      dataLog: [],
    };
  },
  computed: {
    url_upload() {
      return `${process.env.GATE_URL}file/upload`;
    },

    disableAction() {
      const status = this.dataDetail ? this.dataDetail.status : '';
      return this.$route.params.role === 'approver' || this.$route.params.role === 'kepsek' || this.$route.params.status === 'me' || status !== 'draft';
    },

    actionRequester() {
      const status = this.dataDetail ? this.dataDetail.status : '';
      return status === 'draft' && this.$route.params.role === 'requester' && this.$route.params.status !== 'me';
    },

    actionApprover() {
      return this.$route.params.status === 'sent' && this.$route.params.role === 'approver';
    },
  },
  watch: {
  },
  created() {
    this.getListCategory(2).then((resList) => {
      this.list_category = resList.data.data.data.map(e => ({
        id: e.id,
        label: e.title,
      }));

      const param = { id: this.$route.params.id };
      this.detailAdminPembelajaran(param).then((res) => {
        const dataDetail = res.data.data;
        const dataCategory = this.list_category.find(e => e.label === dataDetail.category_name);
        this.dataDetail = res.data.data;

        this.data_master.title = dataDetail.title;
        this.data_master.category = dataCategory;
        this.data_master.file = dataDetail.attachment;
        this.fileGenerate = dataDetail.file_generate;
        this.fileNameDefault = dataDetail.attachment_name ? dataDetail.attachment_name : '';

        this.dataFields = dataDetail.additional_info.map(el => ({
          id: el.id,
          name: el.field_name,
          type: el.type,
          placeholder: el.placeholder,
          field_key: el.field_key,
          value: el.value,
          options: el.options ? el.options.map(val => ({
            id: val,
            name: val,
          })) : [],
          is_delete: false,
          is_editable: false,
          is_mandatory: false,
        }));
        this.showAdditionalInfo = true;
      });
    });

    this.getLog({ id: this.$route.params.id }).then((res) => {
      this.dataLog = res.data.data;
    });
  },
  methods: {
    ...mapActions('jStoreKurikulum', ['getListCategory', 'updateAdminPembelajaran', 'deleteAdminPembelajaran', 'detailAdminPembelajaran', 'submitAdminPembelajaran',
      'approveAdminPembelajaranApp', 'rejectAdminPembelajaranApp', 'getLog']),

    getUrl(data) {
      console.log(data);
      this.data_master.file = data;
    },

    downloadSurat(url) {
      window.open(url);
    },

    submitData() {
      this.$swal({
        title: 'Submit Data',
        text: 'Are you sure want to submit this data?',
        showCancelButton: true,
        confirmButtonText: 'Yes',
      }).then((result) => {
        if (result.value) {
          this.$v.data_master.$touch();
          if (!this.$v.data_master.$error) {
            const param = {
              id: this.$route.params.id,
            };
            this.submitAdminPembelajaran(param).then((res) => {
              if (!res.data.error) {
                setTimeout(() => {
                  this.$router.push('/admin-surat/requester');
                }, 1500);
              }
            });
          }
        }
      });
    },

    saveData() {
      this.$swal({
        title: 'Save Data',
        text: 'Are you sure want to save this data?',
        showCancelButton: true,
        confirmButtonText: 'Yes',
      }).then((result) => {
        if (result.value) {
          this.$v.data_master.$touch();
          if (!this.$v.data_master.$error) {
            this.$refs.jFormCreate.getData().then((params) => {
              const dataAdditional = params.map(e => ({
                field_key: e.field_key,
                value: e.value,
              }));
              const param = {
                id: this.$route.params.id,
                title: this.data_master.title,
                category_id: this.data_master.category.id,
                attachment: this.data_master.file,
                additional_info: dataAdditional,
              };
              this.updateAdminPembelajaran(param).then((res) => {
                if (!res.data.error) {
                  setTimeout(() => {
                    this.$router.push('/admin-surat/requester');
                  }, 1500);
                }
              });
            });
          }
        }
      });
    },

    deleteData() {
      this.$swal({
        title: 'Delete Data',
        text: 'Are you sure want to delete this data?',
        showCancelButton: true,
        confirmButtonText: 'Delete',
      }).then((result) => {
        if (result.value) {
          const param = {
            id: this.$route.params.id,
          };
          this.deleteAdminPembelajaran(param).then((res) => {
            if (!res.data.error) {
              setTimeout(() => {
                this.$router.push('/admin-surat/requester');
              }, 1500);
            }
          });
        }
      });
    },

    approveData() {
      this.$swal({
        title: 'Approve Document',
        text: 'Are you sure want to approve this document?',
        showCancelButton: true,
        confirmButtonText: 'Yes',
        input: 'text',
        type: 'question',
      }).then((result) => {
        if (result.dismiss) {
          // eslint-disable-next-line
          throw {};
        } else {
          const param = {
            id: this.$route.params.id,
            note: result.value,
          };
          this.approveAdminPembelajaranApp(param).then((res) => {
            if (!res.data.error) {
              setTimeout(() => {
                this.$router.push('/admin-surat/approver');
              }, 1500);
            }
          });
        }
      });
    },

    rejectData() {
      this.$swal({
        title: 'Reject Document',
        text: 'Are you sure want to reject this document?',
        showCancelButton: true,
        confirmButtonText: 'Yes',
        input: 'text',
        type: 'question',
        inputValidator: (value) => {
          if (!value) {
            return 'You need to write something!';
          }
          return '';
        },
      }).then((result) => {
        if (result.dismiss) {
          // eslint-disable-next-line
          throw {};
        } else {
          const param = {
            id: this.$route.params.id,
            note: result.value,
          };
          this.rejectAdminPembelajaranApp(param).then((res) => {
            if (!res.data.error) {
              setTimeout(() => {
                this.$router.push('/admin-surat/approver');
              }, 1500);
            }
          });
        }
      });
    },

    cancelData() {
      if (this.$route.params.status === 'me') {
        this.$router.replace('/admin-surat/surat-saya');
      } else {
        this.$router.replace(`/admin-surat/${this.$route.params.role}`);
      }
    },
  },
  validations() {
    return {
      data_master: {
        title: { required },
        category: { required },
        file: { },
      },
    };
  },
};
</script>



// WEBPACK FOOTER //
// src/views/kurikulum/admin-surat/jAdminSuratUpdate.vue